import React from 'react';
import { Logo } from '@/components/Logo';
import { COMPANY, LEGAL_LAST_UPDATED } from '@/content/legal';

const HERO_IMG =
  'https://static.prod-images.emergentagent.com/jobs/6170d9f7-0af6-44a4-9bd0-8b49a78661d1/images/734f0c5408bbc36fd5d93660b9e42d2c03d2e308d6896cb0466df742d64a70a4.png';

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI'];

// Shared layout for Terms.jsx and Privacy.jsx — content lives in content/legal.js.
export default function LegalPage({ title, intro, sections }) {
  const all = [...sections, { title: 'Contact Us', contact: true }];
  return (
    <div className="min-h-screen bg-black text-white">
      <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-obsidian/70 border-b border-white/10">
        <div className="container mx-auto h-16 flex items-center justify-between px-4">
          <Logo />
        </div>
      </nav>

      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden grain">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-fit opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-br from-obsidian via-obsidian/70 to-obsidian/40" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6">
          <h1 className="text-4xl font-bold mb-10 text-center">{title}</h1>

          <div className="space-y-10 text-gray-300 leading-7">
            <section className="space-y-4">
              {intro.map((p, i) => <p key={i}>{p}</p>)}
            </section>

            {all.map((s, i) => (
              <section key={s.title}>
                <h2 className="text-2xl font-semibold mb-4 text-white">
                  {ROMAN[i]}. {s.title}
                </h2>
                {s.contact ? (
                  <div className="bg-zinc-900 rounded-xl p-6 mt-4">
                    <p className="font-semibold text-white">{COMPANY.name}</p>
                    <p className="mt-1 text-sm text-gray-400">Owner and operator of {COMPANY.product}</p>
                    <p className="mt-3">{COMPANY.address}</p>
                    <p className="mt-2">
                      Email: <a href={`mailto:${COMPANY.email}`} className="text-volt hover:underline">{COMPANY.email}</a>
                    </p>
                    <p className="mt-4 text-sm text-gray-400">Last Updated: {LEGAL_LAST_UPDATED}</p>
                  </div>
                ) : (
                  <>
                    {(s.paragraphs || []).map((p, j) => <p key={j} className={j ? 'mt-4' : ''}>{p}</p>)}
                    {s.bullets && (
                      <ul className="list-disc ml-6 mt-4 space-y-2">
                        {s.bullets.map((b, j) => <li key={j}>{b}</li>)}
                      </ul>
                    )}
                    {(s.after || []).map((p, j) => <p key={j} className="mt-4">{p}</p>)}
                  </>
                )}
              </section>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
